import React, {useContext} from 'react';
import {Logo} from 'bonprix-design-system';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter.js';

export default function HeaderLogo({rootUrl}) {
    const {headerLightMode} = useContext(HeaderContext);

    const handleClick = () => {
        LandmarkAdapter.sendClickLandmark('logo');
    };

    return (
        <a
            className="header__bp-logo"
            href={rootUrl}
            title="Zur bonprix Startseite"
            aria-label="Zur bonprix Startseite"
            onClick={handleClick}
        >
            <Logo variant={'bonprix'} className={`logo-img${headerLightMode ? '-light' : ''}`} />
        </a>
    );
}
